import { PriceBox } from './price-box.component';

export * from './price-box.component';
export default PriceBox;

if (!customElements.get('der-tm-roundtrip-offer-panel-price-box')) {
    customElements.define('der-tm-roundtrip-offer-panel-price-box', PriceBox);
}
